import { render, staticRenderFns } from "./login_yingxiao.vue?vue&type=template&id=dd2438b8&scoped=true&"
import script from "./login_yingxiao.vue?vue&type=script&lang=ts&"
export * from "./login_yingxiao.vue?vue&type=script&lang=ts&"
import style0 from "./login_yingxiao.vue?vue&type=style&index=0&id=dd2438b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd2438b8",
  null
  
)

export default component.exports